import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './components/HomePage';
import BasePage from './components/ShowPage';
import ReactGA from 'react-ga4';
import { Analytics } from '@vercel/analytics/react';
import './fonts.css';
import HeaderFooterLayout from './components/HeaderFooterLayout';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';




ReactGA.initialize('G-SCQWPML27C');

const queryClient = new QueryClient();

function InnerApp() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/" element={<HeaderFooterLayout><HomePage /></HeaderFooterLayout>} />
          <Route path="/:id" element={<HeaderFooterLayout><BasePage /></HeaderFooterLayout>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Analytics />
      </QueryClientProvider>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <InnerApp />
    </Router>
  );
}
